import { Component, inject, type OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';

@Component({
  imports: [MatDialogModule],
  selector: 'app-user-activity-modal',
  standalone: true,
  styles: [],
  templateUrl: './user-activity-modal.component.html',
})
export class UserActivityModalComponent implements OnDestroy {
  data = inject<{
    idleTime: number;
    timer: number;
  }>(MAT_DIALOG_DATA);

  interval: ReturnType<typeof setInterval> | undefined;
  counter = 0;
  idleTimeMinutes = 0;

  constructor() {
    if (this.data.timer > 0) {
      this.counter = this.data.timer - 2;
      this.idleTimeMinutes = this.data.idleTime - 1;
      this.interval = setInterval(() => {
        this.counter = this.counter - 1;
        if (!this.counter) {
          clearInterval(this.interval);
        }
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

export function openUserActivityDialog(dialog: MatDialog, timer: number, idleTime: number) {
  const config = new MatDialogConfig();

  config.disableClose = true;
  config.data = {
    idleTime,
    timer,
  };
  config.autoFocus = false;
  config.backdropClass = 'backdrop-modal-panel';

  return dialog.open(UserActivityModalComponent, config);
}
